/**
 * ============================================================
 * SynlabNavbar.js — Global Navigation Bar
 * ============================================================
 *
 * Provides:
 *   -> Synlab logo (links to Home)
 *   -> Navigation links for People / Projects / Publications
 *   -> Responsive mobile collapse menu
 **/

import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

import "./css/SynlabNavbar.css"

// ------------------------------------------------------------
// Component
// ------------------------------------------------------------
function SynlabNavbar() {
  const location = useLocation();

  // Helper to determine active link
  const isActive = (path) => location.pathname === path;


  // ----------------------------------------------------------
  // Render
  // ----------------------------------------------------------
  return (
    <>
      <Navbar expand="md" className="navbar-style" fixed="top">
        <div className="navbar-inner">

          {/* ----- LOGO (links to Home) ----- */}
          <Navbar.Brand as={Link} to="/" className="navbar-logo">
            <img
              src="/logos/synlab-logo.png"
              alt="Synlab Logo"
              className="navbar-logo-img"
            />
          </Navbar.Brand>

          {/* ----- MOBILE TOGGLE ----- */}
          <Navbar.Toggle aria-controls="synlab-navbar" />

          {/* ----- COLLAPSIBLE NAVIGATION LINKS ----- */}
          <Navbar.Collapse id="synlab-navbar" className="justify-content-end">
            <Nav>

              {/* ----- PEOPLE ----- */}
              <Nav.Link
                as={Link}
                to="/people"
                className={isActive("/people") ? "active" : ""}
              >
                People
              </Nav.Link>

              {/* ----- PROJECTS ----- */}
              <Nav.Link
                as={Link}
                to="/projects"
                className={isActive("/projects") ? "active" : ""}
              >
                Projects
              </Nav.Link>

              {/* ----- PUBLICATIONS ----- */}
              <Nav.Link
                as={Link}
                to="/publications"
                className={isActive("/publications") ? "active" : ""}
              >
                Publications
              </Nav.Link>

            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>

      {/* Spacer to offset fixed navbar */}
      <div className="navbar-spacer"></div>
    </>
  );
}

export default SynlabNavbar;
